<template>
  <div id="menuDropdown" :class="exibeMenuCurso ? 'active' : ''" style="float:left;" @mouseleave="ocultarMenu()">
    <div class="dropdown-content box-categorias-menu" :style="col.dropdown">
      <div class="row nav-pills">
        <div :class="col.col + ' pr-0'">
          <h3>Categorias</h3>
          <a v-for="(categoria, index) in categorias" href="javascript:void(0)" @click="exibirDisciplinas(categoria, index)" :class="'nav-link cat' + (index + 1) + ' ' + catActive(categoria)" :key="'categ' + index">{{ categoria.title }}</a>
          <hr>
          <a @click="goToURL('/cursos')" class="btn btn-primary">Explorar todos os cursos</a>
        </div>
        <div v-if="menuCurso.exibirDisciplinas" :class="col.col + ' col-disciplinas  pr-0 pl-0'">
          <h3 class="ml-3">Disciplinas</h3>
          <a :class="'nav-link-cat ' + catHover + ' ' + discActive(disciplina)" v-for="(disciplina, index) in disciplinas" href="javascript:void(0)" @click="exibirCursos(disciplina)" :key="'disc' + index">{{ disciplina.title }}</a>
          <a class="link-regular" @click="goToCategory(menuCurso.categoriaSelecionada)">Ver todas as disciplinas de {{ menuCurso.categoriaSelecionada.title}}</a>
        </div>
        <div v-if="menuCurso.exibirCursos" :class="col.col + ' col-cursos pr-0 pl-0'">
          <h3 class="ml-3">Cursos</h3>
          <a :class="'nav-link-cat ' + catHover" v-for="(curso, index) in cursos" @click="goToCourse(curso)" :key="'curs' + index">{{ curso.title }}</a>
          <a class="link-regular" @click="goToDiscipline(menuCurso.disciplinaSelecionada)">Ver todos os cursos de {{ menuCurso.disciplinaSelecionada.title}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuDropdownCursosB2b',
  components: { },
  data () {
    return {
      menuCurso: {
        exibirDisciplinas: false,
        exibirCursos: false,
        categoriaSelecionada: false,
        disciplinaSelecionada: false
      },
      catHover: 0
    }
  },
  props: {
    categorias: Array,
    exibeMenuCurso: Boolean
  },
  computed: {
    col () {
      let style = []
      if (this.menuCurso.exibirCursos) {
        style['col'] = 'col-sm-4'
        style['dropdown'] = 'left:0;width: 66vw;'
        return style
      } else if (this.menuCurso.exibirDisciplinas) {
        style['col'] = 'col-sm-6'
        style['dropdown'] = 'left:0;width: 44vw;'
        return style
      } else {
        style['col'] = 'col-sm-12'
        style['dropdown'] = 'left:0;width: 22vw;'
        return style
      }
    },
    disciplinas () {
      return this.menuCurso.categoriaSelecionada.disciplinas
    },
    cursos () {
      return this.menuCurso.disciplinaSelecionada.cursos
    },
    dropdownStyle () {
      return 'left:0;width: 66vw;'
    }
  },
  methods: {
    exibirDisciplinas (categoria, index) {
      this.catHover = 'cat' + (index + 1)
      this.menuCurso.categoriaSelecionada = categoria
      this.menuCurso.disciplinaSelecionada = false
      this.menuCurso.exibirDisciplinas = true
      this.menuCurso.exibirCursos = false
    },
    exibirCursos (disciplina) {
      this.menuCurso.disciplinaSelecionada = disciplina
      this.menuCurso.exibirCursos = true
    },
    ocultarMenu () {
      this.menuCurso.exibirDisciplinas = false
      this.menuCurso.exibirCursos = false
      let menuDropdown = document.getElementById('menuDropdown')
      menuDropdown.classList.remove('active')
      this.$emit('ocultarMenu')
    },
    catActive (categoria) {
      return categoria === this.menuCurso.categoriaSelecionada ? 'active' : ''
    },
    discActive (disciplina) {
      return disciplina === this.menuCurso.disciplinaSelecionada ? 'active' : ''
    },
    checkPathIncludesInSomeRoute (path) {
      const routes = this.$router.options.routes
      return routes.some(item => item.path.includes(path))
    },
    goToURL (path, param = '') {
      this.ocultarMenu()
      if (this.checkPathIncludesInSomeRoute(path)) {
        this.$router.push(path + param)
      } else {
        window.location = path + param
      }
    },
    goToCategory (categoria) {
      this.goToURL('/cursos/categoria/', categoria.id)
    },
    goToCourse (curso) {
      this.goToURL('/cursos/detalhe/', curso.url)
    },
    goToDiscipline (disciplina) {
      this.goToURL('/disciplina/', disciplina.url)
    }
  }
}
</script>

<style lang="scss">

</style>